export default __webpack_public_path__ + "static/media/automation.0e9c561b.jp2";